import { format, isToday as isTodayFunc } from 'date-fns'


export const formatMoney = (money: number) => {
    return money.toFixed(2);
}

export const formatDate = (date: Date) => {
    return format(new Date(date), "dd.MM.yyyy HH:mm");
}
export const formatDateToMask = (date: Date, mask: string) => {
    return format(new Date(date), mask);
}
export const formatShortDate = (date: Date) => {
    return format(new Date(date), "dd.MM.yyyy");
}
export const formatDateJson = (date: Date) => {
    return format(new Date(date), "yyyy-MM-dd'T'HH:mm:ss'Z'");
}
export const isToday = (date: Date) => {
    return isTodayFunc(new Date(date));
}